import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { clearTemplate } from 'redux/modules/reportSocialMediaSummary';
import { AdPerformancePreview, OverviewPreview, NextStepsPreview, PageInsightsPreview, RecentPostsPreview } from 'components/ReportPreviews';
import { Spinner } from 'components';
var SocialMediaSummaryPreview = (_dec = connect(function (state) {
  return {
    selectedClient: state.reportBuilder.selectedClient,
    gettingAds: state.reportSocialMediaSummary.gettingAds,
    gettingPosts: state.reportSocialMediaSummary.gettingPosts,
    gettingInsights: state.reportSocialMediaSummary.gettingInsights,
    gettingPageStats: state.reportSocialMediaSummary.gettingPageStats
  };
}, {
  clearTemplate: clearTemplate
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(SocialMediaSummaryPreview, _Component);

  var _super = _createSuper(SocialMediaSummaryPreview);

  function SocialMediaSummaryPreview() {
    var _this;

    _classCallCheck(this, SocialMediaSummaryPreview);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "renderLoading", function () {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          position: 'relative',
          minHeight: 75
        }
      }, /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "renderSectionContent", function (section) {
      switch (section.key) {
        case 'overview':
          return section.enabled ? /*#__PURE__*/React.createElement(OverviewPreview, {
            key: section.key,
            section: section,
            items: _this.props.template.overview.filter(function (item) {
              return item.value;
            }),
            allItems: _this.props.template.overview,
            loading: _this.props.gettingPageStats
          }) : null;

        case 'adPerformance':
          return section.enabled ? /*#__PURE__*/React.createElement(AdPerformancePreview, {
            key: section.key,
            section: section,
            items: _this.props.template.adPerformance.filter(function (item) {
              return item.value;
            }),
            selectedClient: _this.props.selectedClient,
            loading: _this.props.gettingAds
          }) : null;

        case 'recentPosts':
          return section.enabled ? /*#__PURE__*/React.createElement(RecentPostsPreview, {
            key: section.key,
            section: section,
            post: _this.props.template.recentPosts.filter(function (item) {
              return item.value;
            }),
            posts: _this.props.template.recentPosts.filter(function (item) {
              return item.value;
            }),
            selectedClient: _this.props.selectedClient,
            loading: _this.props.gettingPosts
          }) : null;

        case 'pageInsights':
          return section.enabled ? /*#__PURE__*/React.createElement(PageInsightsPreview, {
            key: section.key,
            items: _this.props.template.pageInsights,
            loading: _this.props.gettingInsights
          }) : null;

        case 'nextSteps':
          return section.enabled ? /*#__PURE__*/React.createElement(NextStepsPreview, {
            key: section.key,
            section: section,
            items: _this.props.template.nextSteps.filter(function (item) {
              return item.value;
            }),
            selectedClient: _this.props.selectedClient
          }) : null;

        default:
          return _this.renderLoading(section);
      }
    });

    return _this;
  }

  _createClass(SocialMediaSummaryPreview, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.clearTemplate();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          renderSection = _this$props.renderSection,
          template = _this$props.template;
      var sections = template.sections.filter(function (section) {
        return section.enabled;
      });
      return /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: 16
        }
      }, sections.map(function (section) {
        return renderSection(section, _this2.renderSectionContent(section));
      }));
    }
  }]);

  return SocialMediaSummaryPreview;
}(Component)) || _class);
export { SocialMediaSummaryPreview as default };